import { render, staticRenderFns } from "./ProductListCustom.vue?vue&type=template&id=75a1083e&"
import script from "./ProductListCustom.vue?vue&type=script&lang=js&"
export * from "./ProductListCustom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports